import { Gavel } from '@mui/icons-material';
import React from 'react';

import {
  HeaderContainer,
  TitleRow,
  IconContainer,
  TitleText,
  DescriptionText,
} from './components';

// ============= TYPES =============
export interface MobileHeaderProps {
  /** Title text - defaults to "Court Cases" */
  title?: string;
  /** Description text */
  description?: string;
  /** Optional test ID */
  testId?: string;
}

// ============= DEFAULT VALUES =============
const DEFAULT_DESCRIPTION =
  'Access hundreds of millions of court records and legal opinions from federal, state, and local courts.';

// ============= COMPONENT =============
export const MobileHeader: React.FC<MobileHeaderProps> = ({
  title = 'Court Cases',
  description = DEFAULT_DESCRIPTION,
  testId = 'mobile-header',
}) => {
  return (
    <HeaderContainer data-testid={testId}>
      <TitleRow>
        <IconContainer>
          <Gavel />
        </IconContainer>
        <TitleText variant="h1">{title}</TitleText>
      </TitleRow>
      <DescriptionText>{description}</DescriptionText>
    </HeaderContainer>
  );
};
